import { render } from "./YEremaining.vue?vue&type=template&id=07beccbc&scoped=true"
import script from "./YEremaining.vue?vue&type=script&lang=js"
export * from "./YEremaining.vue?vue&type=script&lang=js"

import "./YEremaining.vue?vue&type=style&index=0&id=07beccbc&lang=scss&scoped=true"
import "./YEremaining.vue?vue&type=style&index=1&id=07beccbc&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07beccbc"]])

export default __exports__